import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";

export default function Unternehmenssteuerung() {
	return (
		<>
			<HelmetProvider>
				<Helmet>
					<title>Beratung bei der Unternehmenssteuerung</title>
					<meta
						name="description"
						content="Beratung bei der Unternehmenssteuerung"
					/>
					<meta
						name="keywords"
						content="Feingeist, Unternehmenssteuerung, Strategische, Berlin"
					/>
				</Helmet>
			</HelmetProvider>
			<div className="beratung_cont" id="leadership">
				<h1>Beratung bei der Unternehmenssteuerung</h1>
				<h2>Das Unternehmen auf Kurs halten</h2>
				<p>
					<em>
						Wir helfen Ihnen, die entscheidenden Informationen zur Steuerung
						Ihres Unternehmens zu erhalten und zu nutzen.
					</em>
				</p>
				<h2>Ihre Vorteile:</h2>
				<ul className="typeset-u-list">
					<li>
						Strategieentwicklung und Ableitung von Maßnahmen anhand der
						Unternehmenssituation
					</li>
					<li>Kosten- und Erlössteuerung</li>
					<li>Strategisches Controlling</li>
				</ul>
				<p>
					Gerade für die Geschäftsführung von kleinen und mittelständischen
					Unternehmen (KMU) ist es bei veränderten Marktbedingungen wichtig,
					Entscheidungen auf Basis einer fundierten Datengrundlage zu treffen.
				</p>
				<p>
					Die Feingeist Unternehmensberatung unterstützt Sie beim Aufbau eines
					Management-Informationssystems (MIS) oder Kennzahlen-Cockpits, um
					Ihnen die Möglichkeit zu geben, fundierte Unternehmensentscheidungen
					mit Weitsicht zu treffen.
				</p>
				<p>
					Eine ganzheitliche Aufnahme der IST-Situation der strategischen und
					digitalen Ausrichtung Ihrer Unternehmung ermöglicht die Feingeist
					Beratung mit dem Business Check und Digitality Check.
				</p>
				<p>Sprechen Sie uns an.</p>
			</div>
		</>
	);
}
